import React from "react"
import { graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import Layout, { Row, Column } from "../components/layout"
import Image from "../components/image"
import { Heading as H, Text, Fancy } from "../components/typography"
import Form from "../components/form"
import Button from "../components/button"
import Card from "../components/card"
import Scale from "../icons/scale.inline.svg"
import Balance from "../icons/balance.inline.svg"
import Heart from "../icons/heart.inline.svg"
import { focusForm } from "../utils"
import useMobileDetect from "use-mobile-detect-hook"

const IndexPage = ({ data }) => {
  const detectMobile = useMobileDetect()

  return (
    <Layout>
      <BackgroundImage Tag="section" id="hero" style={{ minHeight: "100vh" }} fluid={[data.hero.childImageSharp.fluid]}>
        <Row className="inner" justify="center" align="flex-end">
          <Column $size="2" id="hero-text">
            <Image className="logo" alt="Livea Weight Loss Centers logo" src={data.logo} />
            <H $color="white" size="2.5rem">
              It’s <Fancy>Never</Fancy> Been Easier <br />
              To Feel Your Best
            </H>
            <Text $color="white" size="1.4rem">
              Proud to be voted Minnesota's Best Weight Loss Center
            </Text>
          </Column>
          <Column $size="1.25">
            <Form data={data} />
          </Column>
        </Row>
      </BackgroundImage>
      <Row
        as={BackgroundImage}
        Tag="section"
        id="custom-wellness-plans"
        style={{
          backgroundSize: "0",
          backgroundPosition: "",
          backgroundRepeat: "no-repeat",
        }}
        fixed={[data.food.childImageSharp.fixed, data.foodTwo.childImageSharp.fixed]}
      >
        <H as="h2" center>
          Personalized Wellness Plans,<br />
          Professional Guideance,<br />
          Proven Results
        </H>
        <Text center>
          No two people are the same. From our metabolisms to our genetic makeup, there are dozens of factors that can
          influence a person’s overall health and wellness. Here at Livea, we know how important it is to help create
          fully customized and tailored health and wellness plans for each one of our members. Our physician tested meal
          plans are customized for each new member to ensure that your food both matches up with your likes and dislikes
          and easily fits in with your daily schedule. Quit the fads and start the last weight loss plan you will ever
          need today.
        </Text>
      </Row>
      <section style={{ backgroundColor: "#DEEFE7" }} id="how-livea-works">
        <H as="h2" center>
          How Livea Works
        </H>
        <Text center>
          We’ve all heard of those weight loss companies that are constantly having you purchase their products and
          utilize their systems while leaving you with no real long-term solutions. Livea, on the other hand, is built
          and designed to help you make real lasting changes to your long-term health. We do this by breaking our plans
          into three distinct stages.
        </Text>
        <Row className="cards" justify="center" align="center">
          <Card heading="Weight Loss" eyebrow="step 1">
            <Scale />
            Everyone wants to see fast results, which is why we start each wellness plan with the nutrients to get you
            energized and active through delicious meals.
          </Card>
          <Card heading="Balance" eyebrow="step 2">
            <Balance />
            As you get closer to approaching your goal weight, we will begin integrating more options into your daily
            diet that will allow you more versatility in your food consumption.
          </Card>
          <Card heading="Lifestyle" eyebrow="step 3">
            <Heart />
            In this final stage, you will be set up with all the knowledge and resources you need to easily continue
            your healthy eating well past our program.
          </Card>
        </Row>
        <Text style={{ paddingTop: "3.1875rem", paddingBottom: "3.8rem" }} center>
          Once you finish your third step, you’ve done it! You are ready to take your first steps as a fully
          independently healthy individual and continue to eat healthily throughout your daily life. We are happy to
          continue to support you with meals, but you will have all the resources and knowledge you need to be fully
          healthy and maintain your goal weight on your own.
        </Text>
      </section>
      <section id="see-livea">
        <Row className="inner" justify="space-between" align="center">
          <Column $size={1}>
            <H as="h2">See Livea in Action</H>
            <Text clamp="30rem">
              The best way to judge any weight loss plan is through the stories of the people who have tried the
              process. Here are some real stories from Livea users who have reached their goals and continued their
              health journey.
            </Text>
            <Button primary onClick={(e) => focusForm(e, "#primary-form")}>
              Start Your Journey
            </Button>
          </Column>
          <Column $size={1}>
            {detectMobile.isMobile() ? (
              <Image
                className="jenn"
                alt="Lost sixty two pounds. In the first 8 weeks, I lost 21.8 pounds and 18.75 inches. I knew at this point I could do it!"
                src={data.jennMobile}
              />
            ) : (
              <Image
                className="jenn"
                alt="Lost sixty two pounds. In the first 8 weeks, I lost 21.8 pounds and 18.75 inches. I knew at this point I could do it!"
                src={data.jenn}
              />
            )}
          </Column>
        </Row>
      </section>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    food: file(relativePath: { eq: "food-1.png" }) {
      childImageSharp {
        fixed(width: 300) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    foodTwo: file(relativePath: { eq: "food-2.png" }) {
      childImageSharp {
        fixed(width: 300) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    hero: file(relativePath: { eq: "hero.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    badge: file(relativePath: { eq: "badge.png" }) {
      childImageSharp {
        fixed(width: 150) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    jenn: file(relativePath: { eq: "jenn.png" }) {
      childImageSharp {
        fluid(maxWidth: 514) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    jennMobile: file(relativePath: { eq: "jenn-mobile.png" }) {
      childImageSharp {
        fluid(maxWidth: 514) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    logo: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fixed(width: 198) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
  }
`
